<template>
  <div id='panoramaContainer'>
    <div id="view-panorama" class="container container-margin-top is-fluid content-padding">
      <div class="columns">
        <div class="column is-12">
          <div id="panorama-cube-holder">
            <div class="columns is-multiline">
              <div class="column is-one-third-tablet is-2-desktop">
                <label class="label">Frente</label>
                <figure class="image is-square">
                  <figure v-if="!newImages[0] && panoramaInfo.cubes[0]" class="panorama-image fake-dropzone" @click="showDropzone(0)">
                    <img :src="imageUrl(0)">
                    <a class="dz-remove">Remover</a>
                  </figure>
                  <p v-if="newImages[0] || !panoramaInfo.cubes[0]" class="control dropzone-holder">
                    <dropzone id="panoramaPosition0Dz"
                              class="marginless-dropzone dz-dom dz-element"
                              :url="dropzoneUploadUrl+'?position=0'"
                              v-on:vdropzone-success="successUploadImage"
                              v-on:vdropzone-removedfile="removeImage(0)"
                              acceptedFileTypes="image/*"
                    ></dropzone>
                  </p>
                </figure>
              </div>
              <div class="column is-one-third-tablet is-2-desktop">
                <label class="label">Esquerda</label>
                <figure class="image is-square">
                  <figure v-if="!newImages[1] && panoramaInfo.cubes[1]" class="panorama-image fake-dropzone" @click="showDropzone(1)">
                    <img :src="imageUrl(1)">
                    <a class="dz-remove">Remover</a>
                  </figure>
                  <p v-if="newImages[1] || !panoramaInfo.cubes[1]" class="control dropzone-holder">
                    <dropzone id="panoramaPosition1Dz"
                              class="marginless-dropzone dz-dom dz-element"
                              :url="dropzoneUploadUrl+'?position=1'"
                              v-on:vdropzone-success="successUploadImage"
                              v-on:vdropzone-removedfile="removeImage(1)"
                              acceptedFileTypes="image/*"
                    ></dropzone>
                  </p>
                </figure>
              </div>
              <div class="column is-one-third-tablet is-2-desktop">
                <label class="label">Trás</label>
                <figure class="image is-square">
                  <figure v-if="!newImages[2] && panoramaInfo.cubes[2]" class="panorama-image fake-dropzone" @click="showDropzone(2)">
                    <img :src="imageUrl(2)">
                    <a class="dz-remove">Remover</a>
                  </figure>
                  <p v-if="newImages[2] || !panoramaInfo.cubes[2]" class="control dropzone-holder">
                    <dropzone id="panoramaPosition2Dz"
                              class="marginless-dropzone dz-dom dz-element"
                              :url="dropzoneUploadUrl+'?position=2'"
                              v-on:vdropzone-success="successUploadImage"
                              v-on:vdropzone-removedfile="removeImage(2)"
                              acceptedFileTypes="image/*"
                    ></dropzone>
                  </p>
                </figure>
              </div>
              <div class="column is-one-third-tablet is-2-desktop">
                <label class="label">Direita</label>
                <figure class="image is-square">
                  <figure v-if="!newImages[3] && panoramaInfo.cubes[3]" class="panorama-image fake-dropzone" @click="showDropzone(3)">
                    <img :src="imageUrl(3)">
                    <a class="dz-remove">Remover</a>
                  </figure>
                  <p v-if="newImages[3] || !panoramaInfo.cubes[3]" class="control dropzone-holder">
                    <dropzone id="panoramaPosition3Dz"
                              class="marginless-dropzone dz-dom dz-element"
                              :url="dropzoneUploadUrl+'?position=3'"
                              v-on:vdropzone-success="successUploadImage"
                              v-on:vdropzone-removedfile="removeImage(3)"
                              acceptedFileTypes="image/*"
                    ></dropzone>
                  </p>
                </figure>
              </div>
              <div class="column is-one-third-tablet is-2-desktop">
                <label class="label">Topo</label>
                <figure class="image is-square">
                  <figure v-if="!newImages[4] && panoramaInfo.cubes[4]" class="panorama-image fake-dropzone" @click="showDropzone(4)">
                    <img :src="imageUrl(4)">
                    <a class="dz-remove">Remover</a>
                  </figure>
                  <p v-if="newImages[4] || !panoramaInfo.cubes[4]" class="control dropzone-holder">
                    <dropzone id="panoramaPosition4Dz"
                              class="marginless-dropzone dz-dom dz-element"
                              :url="dropzoneUploadUrl+'?position=4'"
                              v-on:vdropzone-success="successUploadImage"
                              v-on:vdropzone-removedfile="removeImage(4)"
                              acceptedFileTypes="image/*"
                    ></dropzone>
                  </p>
                </figure>
              </div>
              <div class="column is-one-third-tablet is-2-desktop">
                <label class="label">Fundo</label>
                <figure class="image is-square">
                  <figure v-if="!newImages[5] && panoramaInfo.cubes[5]" class="panorama-image fake-dropzone" @click="showDropzone(5)">
                    <img :src="imageUrl(5)">
                    <a class="dz-remove">Remover</a>
                  </figure>
                  <p v-if="newImages[5] || !panoramaInfo.cubes[5]" class="control dropzone-holder">
                    <dropzone id="panoramaPosition5Dz"
                              class="marginless-dropzone dz-dom dz-element"
                              :url="dropzoneUploadUrl+'?position=5'"
                              v-on:vdropzone-success="successUploadImage"
                              v-on:vdropzone-removedfile="removeImage(5)"
                              acceptedFileTypes="image/*"
                    ></dropzone>
                  </p>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <figure class="image is-16by9">
            <div id='panoramaViewer'></div>
            <div id='crossairHolder'><div id='crossairInner'></div></div>
          </figure>
        </div>
      </div>
      <div class="columns pantitltfov is-mobile">
        <div class="column is-fifth">
          <p class="control"><span class='bold'>Pan</span>: {{ panoramaInfo.pan.toFixed(4) }}</p>
        </div>
        <div class="column is-fifth">
          <p class="control"><span class='bold'>Tilt</span>: {{ panoramaInfo.tilt.toFixed(4) }}</p>
        </div>
        <div class="column is-fifth">
          <p class="control"><span class='bold'>Fov</span>: {{ panoramaInfo.fov.toFixed(4) }}</p>
        </div>
        <div class="column is-fifth">
        </div>
        <div class="column is-fifth">
        </div>
      </div>
      <div class="columns panoramaButtons">
        <div class="column is-third">
          <a class="button" @click="resetPanoramaView">Voltar à vista inicial</a>
        </div>
        <div class="column is-third">
          <a class="button" @click="setNewStart">Definir nova vista inicial</a>
        </div>
        <div class="column is-third">
          <a class="button is-success" @click="createHotspot">Criar Hotspot</a>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <table class="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Pan</th>
                <th>Tilt</th>
                <th>Fov</th>
                <th>Mostrar</th>
                <th>Editar Texto</th>
                <th>Enquadramento</th>
                <th>Apagar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="point of panoramaPoints" :id="'point_'+point.pointId">
                <td>{{ point.languages[0].name }}</td>
                <td>{{ point.pan }}</td>
                <td>{{ point.tilt }}</td>
                <td>{{ point.fov }}</td>
                <td><a class="button is-success" @click="setView(point.pointId)">Mostrar no panorama</a></td>
                <td><a class="button" @click="updateHotspot(point.pointId)">Editar texto</a></td>
                <td><a class="button" @click="setNewView(point.pointId)">Definir novo enquadramento</a></td>
                <td><a class="button is-danger" @click="deleteHotspot(point.pointId)">Apagar</a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
   </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import PanoCoaches from '../../plugins/panoCoaches.js'
  import { API_ROOT } from '../../config'
  import Dropzone from '../Util/DropzoneForm'
  import HotspotModal from './PanoramaHotspotModal'
  import DeleteModal from './PanoramaDeleteModal'

  const CardHotspotModalComponent = Vue.extend(HotspotModal)
  const CardDeleteModalComponent = Vue.extend(DeleteModal)
  
  export default {
    components: {
      Dropzone,
      HotspotModal,
      DeleteModal
    },
    props: {
      panoramaData: Object
    },

    data () {
      return {
        dropzoneUploadUrl: API_ROOT + 'resource/panorama/upload/' + this.$store.state.route.params.id,
        panoCoches: null,
        // panoramaId: null,
        panoramaInfo: {
          pan: 0,
          tilt: 0,
          fov: 90,
          cubes: [],
          points: []
        },
        originalInformation: null,
        newImages: {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true,
          5: true
        }
      }
    },

    mounted () {
      var _this = this

      this.$nextTick(function () {
        setTimeout(function () {
          _this.panoCoches = new PanoCoaches('panoramaViewer', {basePath: 'http://services.mnc.takemedia.pt/media/coach/panoramas/'})
          var changeInfo = {}
          for (var f in _this.panoramaInfo.cubes) {
            changeInfo[f] = _this.panoramaInfo.cubes[f]
          }
          _this.panoCoches.changePanoramaImage(changeInfo)
          changeInfo = {
            pan: _this.panoramaInfo.pan,
            tilt: _this.panoramaInfo.tilt,
            fov: _this.panoramaInfo.fov
          }
          _this.panoCoches.setPanTiltFov(changeInfo)

          for (var p in _this.panoramaData.panoramaPoints) {
            var info = _this.panoramaData.panoramaPoints[p]
            _this.panoCoches.addNewHotspot(info.languages[0].name, info.pointId, {pan: info.pan, tilt: info.tilt, fov: info.fov})
          }
        }, 500)
      })

      this.drawAnimation()

      if (this.panoramaData) {
        for (var i in this.panoramaData.panoramaCubes) {
          let position = this.panoramaData.panoramaCubes[i].position
          this.panoramaInfo.cubes[position] = this.panoramaData.panoramaCubes[i].imagePath
          this.newImages[position] = false
        }
        if (!this.originalInformation) {
          // this.panoramaId = this.panoramaData.id
          this.originalInformation = {pan: null, tilt: null, fov: null}
          this.originalInformation.pan = this.panoramaInfo.pan = this.panoramaData.pan
          this.originalInformation.tilt = this.panoramaInfo.tilt = this.panoramaData.tilt
          this.originalInformation.fov = this.panoramaInfo.fov = this.panoramaData.fov
          this.originalInformation.points = this.panoramaData.panoramaPoints
        }
      }
    },

    computed: {
      panoramaPoints () {
        if (this.panoramaData) {
          return this.panoramaData.panoramaPoints
        } else {
          return []
        }
      },
      panoramaCubes () {
        if (this.panoramaData) {
          return this.panoramaData.panoramaCubes
        } else {
          return []
        }
      },
      currentEvent () {
        return window.store.state.event.nextEvent
      },
      panoramaId () {
        return this.panoramaData ? this.panoramaData.id : null
      }
    },
    methods: {
      successUploadImage: function (file, serverInfo) {
        if (serverInfo) {
          var changeInfo = {}
          changeInfo[serverInfo.position] = serverInfo.file
          this.panoCoches.changePanoramaImage(changeInfo)
          this.panoramaInfo.cubes[serverInfo.position] = serverInfo.file
          this.newImages[serverInfo.position] = false
        }
      },
      removeImage: function (position) {
        if (!this.newImages[position]) {
          let openCardModal = (propsData = {}) => {
            return new CardDeleteModalComponent({
              el: document.createElement('div'),
              propsData
            })
          }
          openCardModal({
            title: 'Apagar Face',
            panoramaId: parseInt(this.panoramaData.id),
            id: parseInt(position),
            warningText: 'Tem a certeza que pretende apagar esta face do panorama?',
            type: 'cube'
          })
        }
      },
      drawAnimation: function () {
        if (this.panoCoches) {
          try {
            var ptf = this.panoCoches.getPanTiltFov()
            this.panoramaInfo.pan = ptf.pan
            this.panoramaInfo.tilt = ptf.tilt
            this.panoramaInfo.fov = ptf.fov
          } catch (err) {
          }
        }
        window.requestAnimationFrame(this.drawAnimation)
      },
      showDropzone (selector) {
        this.removeImage(selector)
      },
      imageUrl (imageIndex) {
        return API_ROOT + 'media/coach/panoramas/' + this.panoramaInfo.cubes[imageIndex]
      },
      resetPanoramaView () {
        if (this.originalInformation) {
          var changeInfo = {
            pan: this.originalInformation.pan,
            tilt: this.originalInformation.tilt,
            fov: this.originalInformation.fov,
            moveTo: true
          }
        }
        this.panoCoches.setPanTiltFov(changeInfo)
      },
      setNewStart () {
        if (this.panoCoches) {
          var ptf = this.panoCoches.getPanTiltFov()
          this.originalInformation.pan = ptf.pan
          this.originalInformation.tilt = ptf.tilt
          this.originalInformation.fov = ptf.fov
          window.store.dispatch('updatePanorama', {
            panoramaId: this.panoramaId,
            pan: ptf.pan,
            tilt: ptf.tilt,
            fov: ptf.fov
          })
        }
      },
      setNewView (id) {
        if (this.panoCoches) {
          var ptf = this.panoCoches.updateHotspot(id)
          window.store.dispatch('updatePanoramaPoint', {
            pointId: id,
            pan: ptf.pan,
            tilt: ptf.tilt,
            fov: ptf.fov
          })
        }
      },
      createHotspot () {
        let openCardModal = (propsData = {}) => {
          return new CardHotspotModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }
        openCardModal({
          title: 'Criar Hotspot',
          panoramaId: this.panoramaId,
          hotspotData: this.panoCoches.getPanTiltFov()
        })
      },
      updateHotspot (id) {
        let openCardModal = (propsData = {}) => {
          return new CardHotspotModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }
        var pointData = null
        for (var i in this.panoramaData.panoramaPoints) {
          if (this.panoramaData.panoramaPoints[i].pointId === id) {
            pointData = this.panoramaData.panoramaPoints[i]
          }
        }
        openCardModal({
          title: 'Editar Hotspot',
          panoramaId: parseInt(this.panoramaId),
          pointId: parseInt(id),
          hotspotData: pointData
        })
      },
      deleteHotspot (id) {
        let openCardModal = (propsData = {}) => {
          return new CardDeleteModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }
        openCardModal({
          title: 'Apagar Hotspot',
          panoramaId: parseInt(this.panoramaData.id),
          id: parseInt(id),
          warningText: 'Tem a certeza que pretende apagar este Hotspot?',
          type: 'hotspot'
        })
      },
      setView (val) {
        if (this.panoCoches) {
          for (var i in this.panoramaData.panoramaPoints) {
            if (this.panoramaData.panoramaPoints[i].pointId === val) {
              var changeInfo = {
                pan: this.panoramaData.panoramaPoints[i].pan,
                tilt: this.panoramaData.panoramaPoints[i].tilt,
                fov: this.panoramaData.panoramaPoints[i].fov,
                moveTo: true
              }
              this.panoCoches.setPanTiltFov(changeInfo)
              break
            }
          }
        }
      }
    },

    watch: {
      currentEvent: function (val) {
      },
      panoramaPoints: function (val) {
        if (this.panoCoches) {
          var _this = this
          this.panoCoches.clearHotspot()
          for (var p in val) {
            var info = val[p]
            this.panoCoches.addNewHotspot(info.languages[0].name, info.pointId, {pan: info.pan, tilt: info.tilt, fov: info.fov}, function (pointId) {
              _this.panoCoches.gotoHotspot(pointId)
            })
          }
        }
      },
      panoramaCubes: function (val) {
        this.panoramaInfo.cubes = []
        this.newImages = {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true,
          5: true
        }
        var changeInfo = {}
        changeInfo = ['blank.jpg', 'blank.jpg', 'blank.jpg', 'blank.jpg', 'blank.jpg', 'blank.jpg']
        for (var p in val) {
          var position = val[p].position
          this.panoramaInfo.cubes[position] = val[p].imagePath
          this.newImages[position] = false
          changeInfo[position] = val[p].imagePath
        }
        if (this.panoCoches) {
          this.panoCoches.changePanoramaImage(changeInfo)
        }
      }
    }
  }
</script>

<style lang="scss">
  #panoramaViewer {
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  .hidden {
    visibility: hidden;
  }
  .dropzone-holder {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    min-height: initial;
  }
  .dz-element {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    min-height: initial;
  }
  #panorama-cube-holder .dz-image-preview {
    width: 100%;
    height: 100%;
  }
  #panorama-cube-holder .dropzone .dz-preview .dz-image img {
    width: 100%;
    height: auto;
  }
  #panorama-cube-holder .dz-image {
    width: inherit !important;
    height: inherit !important;
  }
  #panorama-cube-holder .fa-coach-preview {
    font-size: 1em !important;
  }
  #panorama-cube-holder .dropzone .dz-preview .dz-error-mark {
    margin: 0px
  }
  #panorama-cube-holder .dropzone .dz-preview .dz-error-mark {
    top: 12%;
    right: 20%;
  }
  #panorama-cube-holder .dropzone .dz-preview .dz-error-mark {
    left: inherit;
  }
  #panorama-cube-holder .dropzone .dz-preview .dz-error-message {
    top: 30%;
    left: calc(50% - 70px);
  }
  #panorama-cube-holder .control {
    position: absolute;
  }
  .bold {
    font-weight: bold;
  }
  .pantitltfov {
    font-size: 12px;
  }
  .pantitltfov .column {
    padding-top: 0px;
  }
  .panoramaButtons .button {
    width: 100%;
  }
  .ggskin.ggskin_bk {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: -1;
    border-radius: 20px;
    opacity: 0.5;
  }
  .ggskin.ggskin_textdiv {
    padding: 10px 20px;
    text-align: center;
  }
  #crossairHolder {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 25px;
    height: 25px;
  }

  #crossairInner {
    width: 100%;
    height: 100%;
    position: absolute;
    top: -50%;
    left: -50%;
    background: url(~assets/images/crossair.png);
    z-index: 9999;
  }
</style>


// WEBPACK FOOTER //
// PanoramaContainer.vue?510ebcc6